'use es6';

import { getUserTextKey } from '../../../utils/userUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const UserCell = ({
  user,
  userId,
  isRestoreReportsCell = false
}) => {
  const userTextKey = getUserTextKey(user, userId, isRestoreReportsCell);
  return /*#__PURE__*/_jsx("td", {
    children: user ? /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      disabled: !user.get('removed'),
      title: user.get('email') ? user.get('email') : user.get('fullName'),
      children: /*#__PURE__*/_jsx("div", {
        children: userTextKey === 'fullName' ? user.get('fullName') : /*#__PURE__*/_jsx(FormattedMessage, {
          message: userTextKey
        })
      })
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: userTextKey
    })
  });
};
export default UserCell;